import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomValidationService {

  patternValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      //const regex = new RegExp('/^(?=.*[A-Za-z])(?=.*d)(?=.*[@$!%*#?&])[A-Za-zd@$!%*#?&]{8,}$/');
      const regex = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*[@$!%*#?&.-]).{8,}$');
      const valid = regex.test(control.value);
      return valid ? null : { invalidPassword: true };
    };
  }

  MatchPassword(password: string, confirmPassword: string) {
    return (formGroup: FormGroup) => {
      const passwordControl = formGroup.controls[password];
      const confirmPasswordControl = formGroup.controls[confirmPassword];

      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      if (confirmPasswordControl.errors && !confirmPasswordControl.errors.passwordMismatch) {
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }
    }
  }

  
  static maxSizeFile(control: FormControl): { [key: string]: any } | null {
    if (control.value != null){
      const file: File = control.value;
      let errors: string[] = [];
      //console.log(control.value);
      //console.log(file.name);
      //console.log(file.size);
      if (file.size > (2*1024)*1024) {                 
        return ({error_file_size:`${file.name} excede el valor maximo de 2 MB\n`});
      }
      else{
        return null;
      }
    }
    else{return null;}
      
  }





  verificaValorMenor(desde:string, hasta:string){
    return (formGroup: FormGroup) => {
      const v1 = formGroup.controls[desde];
      const v2 = formGroup.controls[hasta];
      if (v1>v2){
        v2.setErrors({noEsMayor: true})
      }
      else{
        v2.setErrors(null)
      }
    }
  }


/*
  userNameValidator(userControl: AbstractControl) {
    return new Promise(resolve => {
      setTimeout(() => {
        if (this.validateUserName(userControl.value)) {
          resolve({ userNameNotAvailable: true });
        } else {
          resolve(null);
        }
      }, 1000);
    });
  }

  validateUserName(userName: string) {
    const UserList = ['ankit', 'admin', 'user', 'superuser'];
    return (UserList.indexOf(userName) > -1);
  }
  */
}